// MobileNavWrapper - Wrapper global pour afficher la navigation mobile sur TOUTES les pages
// Affiche MobileBottomNav par défaut
// Visible uniquement sur mobile (md:hidden)

import React from 'react';
import { useLocation } from 'react-router-dom';
import MobileBottomNav from './MobileBottomNav';
import AbracadaTchatFAB from './AbracadaTchatFAB';

// Pages où on ne veut PAS afficher de navigation mobile du tout
// Car ces pages ont leur PROPRE navbar intégrée
const EXCLUDED_PATHS = [
  '/admin',
  '/espace-client',
  '/reseau/reels',  // Cinéma plein écran
  '/abracadaworld',  // Page AbracadaWorld - layout indépendant
  '/cockpit-pro',  // Cockpit Pro a sa propre navbar dans CockpitAssistantUnified
  '/cockpit-particulier',  // Cockpit Particulier a sa navbar dans CockpitAssistantUnified
  '/decrire-projet',  // Page plein écran isolée
];

// Vérifie si la page courante doit exclure toute navigation mobile
const shouldExcludeNav = (pathname) => {
  return EXCLUDED_PATHS.some(path => pathname.startsWith(path));
};

export default function MobileNavWrapper() {
  const location = useLocation();
  
  // Ne pas afficher sur certaines pages (elles ont leur propre navbar)
  if (shouldExcludeNav(location.pathname)) {
    return null;
  }

  // Par défaut, afficher MobileBottomNav
  return (
    <>
      <MobileBottomNav />
      <AbracadaTchatFAB />
    </>
  );
}
